import { render, staticRenderFns } from "./IconSwitchHorizontalOutline.vue?vue&type=template&id=0a1bbe7c"
import script from "./IconSwitchHorizontalOutline.vue?vue&type=script&lang=js"
export * from "./IconSwitchHorizontalOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports